import { render, staticRenderFns } from "./QuickReserv.vue?vue&type=template&id=acb08bd2&scoped=true&"
import script from "./QuickReserv.vue?vue&type=script&lang=ts&"
export * from "./QuickReserv.vue?vue&type=script&lang=ts&"
import style0 from "./QuickReserv.vue?vue&type=style&index=0&id=acb08bd2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acb08bd2",
  null
  
)

export default component.exports